/* eslint-disable global-require */
/**
 * 公共语言配置
 */
export default {
  // 网站名称
  websiteName: 'Think Academy US',
  // 导航配置
  navigationLinks: [
    {
      name: 'Home',
      url: '/',
      target: '',
    },
    {
      name: 'Courses',
      url: '/courses',
      target: '',
    },
    {
      name: 'Math Competitions',
      url: '/courses/aggregationalfooterOtherInfo-detail/225',
      target: '',
      children: [
        {
          name: 'Math Kangaroo',
          url: '/courses/aggregational-detail/229',
          target: '',
        },
        {
          name: 'AMC 8',
          url: '/courses/aggregational-detail/246',
          target: '',
        },
        {
          name: 'AMC 10',
          url: '/courses/aggregational-detail/225',
          target: '',
        },
        {
          name: 'World Think Cup',
          url: 'https://us.thethinkacademy.com/world-think-cup-2',
          isLink: true,
          target: '_blank',
        },
      ],
    },
    {
      name: 'Free Resources',
      url: '/resources',
      target: '',
      children: [
        {
          name: 'Math Workbooks',
          url: '/resources',
          target: '',
        },
        {
          name: 'Free Evaluation',
          url: '/1-to-1-assessment',
          target: '',
        },
      ],
    },
    {
      name: 'Blog',
      url: 'https://blog.thethinkacademy.com',
      className: '',
      isLink: true,
      target: '_self',
    },
    {
      name: 'About us',
      url: '/about-us',
      target: '',
      children: [
        {
          name: 'Learning Platform',
          url: '/download',
          target: '',
        },
        {
          name: 'Faculty',
          url: '/teachers',
          className: '',
          isLink: true,
        },
        {
          name: 'Careers',
          url: '/careers/job-listings',
          className: '',
          target: '_blank',
          isLink: true,
        },
        {
          name: 'About TAL',
          url: 'https://en.100tal.com',
          className: 'item-about',
          target: '_blank',
        },
        {
          name: 'Investor Relations',
          url: 'https://ir.100tal.com',
          target: '_blank',
        },
      ],
    },
  ],
  // 用户
  userNavigationLinks: [
    {
      name: 'My Account',
      url: '/settings',
      target: '',
    },
    {
      name: 'My Courses',
      url: '/my-courses/list',
      target: '',
    },
    {
      name: 'My Orders',
      url: '/order/list',
      target: '',
    },
    // {
    //   name: 'My Subscription',
    //   url: '/subscription-manage',
    //   target: '',
    // },
    {
      name: 'Unpaid Courses',
      url: '/my-unpaid-courses/list',
      target: '',
      mark: true,
    },
    {
      name: 'My Family',
      url: '/my-account',
      target: '',
    }, {
      name: 'Sign Out',
      url: '',
      target: '',
      isLink: false,
    }],

  // 个人中心侧边导航
  sideNavigationLinks: [{
    list: [
      {
        name: 'My Courses',
        url: '/my-courses/list',
        keyword: 'my-courses',
        iconName: 'icon-course',
      },
      {
        name: 'Test Results',
        url: '/test/test-results',
        keyword: 'test-results',
        handle: 'toPlacementTest',
        iconName: 'icon-test',
      },
      {
        name: 'My Orders',
        url: '/order/list',
        keyword: 'order',
        iconName: 'icon-order',
      },
      // {
      //   name: 'Subscription Management',
      //   url: '/subscription-manage',
      //   keyword: 'subscription-manage',
      //   iconName: 'icon-subscription',
      // },
    ],
  }, {
    list: [
      {
        name: 'Unpaid Courses',
        url: '/my-unpaid-courses/list',
        keyword: 'my-unpaid-courses',
        iconName: 'icon-upaid-courses',
        mark: true,
      },
      {
        name: 'Class Reschedule/Transfer',
        url: '/my-class-transfer',
        keyword: 'my-class-transfer',
        iconName: 'icon-switch',
      },
      {
        name: 'My Coupons',
        url: '/my-coupons/list',
        keyword: 'my-coupons',
        iconName: 'icon-coupon',
      },
      {
        name: 'Wish List',
        url: '/my-wish/list',
        keyword: 'my-wish',
        iconName: 'icon-wish-list',
      },
    ],
  }],

  // 底部栏配置
  // 关于我们
  aboutUs: {
    title: 'About Us',
    links: [{
      name: 'Think Academy',
      url: '/about-us',
      target: '_blank',
    }, {
      name: 'About TAL',
      url: 'https://en.100tal.com',
      target: '_blank',
    }, {
      name: 'Job Opportunities',
      url: '/careers',
      target: '_self',
    }],
  },
  // 联系我们
  contactUs: {
    title: 'Contact Us',
    displayType: 'contact',
  },

  // 友情链接
  otherSchool: {
    title: 'Our Global Branches',
  },

  // 关注社交账号
  follows: {
    title: 'Follow Think Academy',
    links: [{
      icon: 'icon-youtube2',
      name: 'Youtube',
      link: 'https://www.youtube.com/channel/UCuopVXHI1N9jTRhSULgSlGw',
      target: '_blank',
      linkType: 'link',
    }, {
      icon: 'icon-facebook2',
      name: 'Facebook',
      link: 'https://www.facebook.com/people/Think-Academy-US-Online/61559812710981/',
      target: '_blank',
      linkType: 'link',
    }, {
      icon: 'icon-wechat2',
      name: 'WeChat',
      link: require('assets/images/common/qrcode-us.png'),
      target: '',
      linkType: 'qrcode',
      tipText: 'Follow us on WeChat',
    }, {
      icon: 'icon-whatsapp',
      name: 'WhatsApp',
      link: 'https://chat.whatsapp.com/LTeCh9k6Afz3APzIuLIcRZ',
      target: '_blank',
      linkType: 'link',
    }],
  },

  // 法务协议
  policyLinks: [{
    name: 'Terms of Use',
    url: '/terms-of-use',
    target: '_blank',
  }, {
    name: 'Privacy Policy',
    url: '/privacy-policy',
    target: '_blank',
  }, {
    name: 'Investor Relations',
    url: 'https://ir.100tal.com',
    target: '_blank',
  }, {
    name: 'Do Not Sell My Information',
    url: 'https://forms.office.com/Pages/ResponsePage.aspx?id=l21_wFwXRkaZz0F63yISOydaUs6lLs9BjNaZ2g4bQTZUQzFFQVBIUDQ4NkxUMllJUkJUVEQxUE5QUC4u&embed=true',
    target: '_blank',
  }],

  // 侧边栏配置
  rightTools: [{
    name: 'Youtube',
    icon: 'icon-youtube-new',
    link: 'https://www.youtube.com/channel/UCuopVXHI1N9jTRhSULgSlGw',
    target: '_target',
    type: 'link',
  }, {
    name: 'Facebook',
    icon: 'icon-facebook',
    link: 'https://www.facebook.com/people/Think-Academy-US-Online/61559812710981/',
    target: '_target',
    type: 'link',
  }, {
    name: 'WeChat',
    icon: 'icon-wechat',
    link: require('assets/images/common/qrcode-us.png'),
    target: '',
    type: 'qrcode',
    config: {
      tip: 'Follow us on WeChat',
    },
  }, {
    name: 'WhatsApp',
    icon: 'icon-whatsapp',
    link: 'https://chat.whatsapp.com/LTeCh9k6Afz3APzIuLIcRZ',
    target: '_blank',
    type: 'link',
  }, {
    name: 'Help',
    icon: 'icon-robot',
    link: '',
    target: '',
    type: 'chat',
  }],

  // 关注社交账号
  follow: {
    facebookUrl: 'https://www.facebook.com/people/Think-Academy-US-Online/61559812710981/',
    whatsappQrcode: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/common/whatsapp-qrcode.png',
    wechatQrcode: require('assets/images/common/qrcode-us.png'),
    youtubeUrl: 'https://www.youtube.com/channel/UCuopVXHI1N9jTRhSULgSlGw',
    instagramUrl: '',
    linkedinUrl: '',
    twitterUrl: '',
  },
  // 工作机会
  jobOpportunities: '/careers/job-listings',
  // footer其他信息
  footerOtherInfo: [{
    icon: require('assets/images/common/icon-wasc.png'),
    name: 'Think Academy is a WASC Accredited School',
    link: '',
    iconHeight: 28,
  },
  // {
  //   icon: require('assets/images/common/icon-darktm.png'),
  //   name: 'Think Academy is listed by the kidSAFE Seal Program',
  //   link: 'https://www.kidsafeseal.com/certifiedproducts/think_academy.html',
  //   iconHeight: 28,
  // }
  ],
  // 公司信息
  companyInfo: [{
    text: '1081 S De Anza Blvd, San Jose, CA 95129',
    isLink: false,
  }, {
    text: '© 2024 Think Academy International Education Inc.',
    isLink: false,
  }, {
    text: '京ICP备13017119号-5',
    isLink: true,
    link: 'https://beian.miit.gov.cn/',
  }],
  // 联系方式
  contactPhone: '+1 (844) 844-6587',
  contactEmail: 'contact@thethinkacademy.com',

  // 联系信息列表化
  // 标题+内容
  contactList: [],

  // app下载地址
  GooglePlayDownloadUrl: 'https://play.google.com/store/apps/details?id=com.xes.america.activity',
  appStoreDownloadUrl: 'https://apps.apple.com/cn/app/think-academy/id1481316950',
  termsOfRefundUrl: '/refund-policy',

  // 日期格式化方式
  dateFormat: 'MM/DD/YYYY',
  dateTimeFormat: 'MM/DD/YYYY HH:mm:ss',
  dayMonthFormat: 'MM.DD',

  // 货币格式
  isKeepTwoDecimal: '0',

  // 税费名称
  taxName: 'Tax',

  // 分享相关
  share: {
    downPoster: 'Save poster',
    copyLink: 'Copy link',
    clear: 'Cancel',
    downPosterSu: 'Sucess',
    referralDes: 'Copy the referral, long press and paste when sharing.',
    copyReferral: 'Copy the referral',
    copySu: 'Success!\n Send it to your friends!',
    sownSu: 'Success!\n Send it to your friends!',
    access: 'Please allow to access your Photos in the Settings.',
    shareTit: 'I have found a great course! Join my Group Buy to enjoy the discount!',
    weChat: 'WeChat',
    moments: 'Moments',
  },
  allowMaterialsNum: 0,
}
